/*
 * @Author: wblijinyang
 * @FilePath: /mall-fe/src/libs/urls.ts
 * @Description: 工程运行地址常量信息
 */
export { resizeImage } from './universal';

export const ENV = process.env.ENV || 'zjst'; // 使用测试环境
export const BasePath = ['dev', 'st'].includes(ENV) ? '/mallfe' : '';


export const STATIC_HREFS = {
  zjdev: `https://public-test-shop.oss-cn-shenzhen.aliyuncs.com`,
  zjst: `https://public-test-shop.oss-cn-shenzhen.aliyuncs.com`,
  zjpre: `https://static-tg.3jyx.cn`,
  zjga: `https://static-tg.3jyx.cn`,
};

export const API_SSO = 'api/ifs/v1/sso';

// 技术支持地址，这个地址是写死的，不需要根据不同的环境返回不同的地址
export const supportUrl = 'https://www.tabe.cn/';

/**
 * 测试环境需要用 location.href 跳转的，需要拼个 basePath
 */
export function getHref(href: string) {
  return href;
}

export function isIOS(ua: string) {
  return ua?.includes('iPhone');
}
/**
 * 企点客服地址
 * SPECIAL_PRO_SHOP 云采自营和测试环境客服URL
 * GENERAL_URL 生产环境且非云采自营店铺的客服URL
 * LOGISTICS_EXPRESS_URL 物流快递客服地址
 */
export const QIDIAN_SERVICEURL = {
  SPECIAL_PRO_SHOP: `https://wpa1.qq.com/STPaoL40?_type=wpa&qidian=true`,
  GENERAL_URL: `https://wpa1.qq.com/isVhkFg3?_type=wpa&qidian=true`,
  LOGISTICS_EXPRESS_URL: `https://wpa1.qq.com/sm7dAX2j?_type=wpa&qidian=true`,
};

export const WOFENG_SERVICE_URL = {
  YXSC_PC: `https://zj3jyx.s2.udesk.cn/im_client/?web_plugin_id=63156&group_id=61048`,
  YXSC_MOBILE: `https://zj3jyx.s2.udesk.cn/im_client/?web_plugin_id=63377&group_id=61048`,
};

export const HELP_CENTER_URL_PREFIX = ['zjdev', 'zjst'].includes(ENV)
  ? 'https://mall-st.3jyx.cn/smart-settlement-frontend'
  : 'https://www.3jyx.cn/smart-settlement-frontend';
